import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { Subject, BehaviorSubject } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';

// import { AuthData, ResponseLogin, RespuestaGen } from './auth-data.model';
import * as backInter from './auth-data.model';
import { ModalComponent } from 'app/main/pagina/modal/modal.component';

import { DATOS_API } from './auth.datos';

import { LoginService } from 'app/services/login.service';
import { UserService } from 'app/services/user.service';

import { QuickPanelService } from "app/layout/components/quick-panel/quick-panel.service";

@Injectable({ providedIn: 'root'})
export class AuthService{
  detectorDispositivo:any;
  detectorNavegador:any;
  private isAuthenticated = false;
  private token: string;
  private tokenVersion: string;
  private tokenTimer: any;
  private authStatusListener = new Subject<any>();

  private mensajeOrigen = new BehaviorSubject('');
  mensajeActual = this.mensajeOrigen.asObservable();

  private mensajeOrigenQuick = new BehaviorSubject('');
  mensajeActualQuick = this.mensajeOrigenQuick.asObservable();

  private mensajeOrigenToolbarNotif = new BehaviorSubject('');
  mensajeActualToolbarNotif = this.mensajeOrigenToolbarNotif.asObservable();

  ///datos usuario empresa
  private idUsuario: string;
  private infoUsu: backInter.infoUsuario;
  private instituto: string;

  constructor(
      private http:HttpClient,
      private router: Router,
      private dialog: MatDialog,
      private loginService: LoginService,
      private userService: UserService,
      private qps: QuickPanelService
    ) {}

  /////////
  setPasswordToken(token){
    sessionStorage.setItem('token', token);
    this.token=token;
    console.log("New token "+this.token);
  }
  nullToken(){
    sessionStorage.removeItem('token');
    this.token=null;
  }
  getToken() {
    return this.token;
  }

  setToken_provicional(token){
    return this.token;
  }

  getTokenVersion() {
    return this.tokenVersion;
  }

  getAuthStatusListener() {
    return this.authStatusListener.asObservable();
  }

  getIsAuth() {
    return this.isAuthenticated;
  }

  getIdUsuario(){
    return this.idUsuario;
  }
  getInfoUsuario(){
    return this.infoUsu;
  }
  getInstituto(){
    return this.instituto;
  }

  private setAuthTimer(duration: number) {
    //console.log("programando timer: "+(duration/60000));
    this.tokenTimer = setTimeout(() => {
      this.logout();
    }, duration);
  }


  private saveAuthData(token: string, tokenVersion: string, expirationDate: Date, idUsuario: string, companyID: string, instituto: string, empresaPadre?: string) {
    sessionStorage.setItem('token', token);
    localStorage.setItem('tokenVersion', tokenVersion);
    localStorage.setItem('expiration', expirationDate.toISOString());
    localStorage.setItem('companyID', companyID);
    localStorage.setItem('idUsuario', idUsuario);
    localStorage.setItem('instituto', instituto);
    if(empresaPadre){
      localStorage.setItem('empresaPadre', empresaPadre);
      console.log("Empresa padre");
      console.log(localStorage.getItem('empresaPadre'));
    }

  }

  private clearAuthData(fromODS?:boolean) {
    //sessionStorage.removeItem('token');
    localStorage.removeItem('expiration');
    localStorage.removeItem('companyID');
    localStorage.removeItem('idUsuario');
    localStorage.removeItem('userData');
    localStorage.removeItem('fechaProducto');
    localStorage.removeItem('instituto');
    localStorage.removeItem('empresaPadre');
    localStorage.removeItem('tipoProducto');
    localStorage.removeItem('productoID');
    localStorage.removeItem('totalIdiomas');
    localStorage.removeItem('id_CT');
    localStorage.removeItem('productoIdNorm35');
    localStorage.removeItem('Leveuser');
    localStorage.removeItem('producto35');
    localStorage.removeItem('instituto_id');
    localStorage.removeItem('levelUser_tmp');
    localStorage.removeItem('empresaID');
    localStorage.removeItem('encuestaID');
    localStorage.removeItem('tipoproductoID');
    localStorage.removeItem('ctSeleccionadoId');
    localStorage.removeItem('tipoNorma35');
    localStorage.removeItem('tipo35_tmp');
    localStorage.removeItem('ctProductoId');
    localStorage.removeItem('CultureTurquia');
    localStorage.removeItem('CA_CHVERSION');
    localStorage.removeItem('CultureCH');
    localStorage.removeItem('Posculture');
    localStorage.removeItem('Idinstituto');
    localStorage.removeItem('busquedaEmpresa');
    localStorage.removeItem('CultureMexico');
    localStorage.removeItem('numPracticas');
    localStorage.removeItem('instituto_correos');
    localStorage.removeItem('tipoProct');
    localStorage.removeItem('idUser');
    localStorage.removeItem('nivel');
    localStorage.removeItem('user');
    localStorage.removeItem('CultureESP');
    localStorage.removeItem('Surveystaus_portal');
    localStorage.removeItem('user_padre');
    localStorage.removeItem('nameCity');
    localStorage.removeItem('date_log');
    localStorage.removeItem('idSurvey_status');
    localStorage.removeItem('idEmpresa_surveysatus');
    localStorage.removeItem('fechamessage');
    localStorage.removeItem('offsetPipe_message');
    localStorage.removeItem('NivelUsuarioRequerimientosTecnicos');
    localStorage.removeItem('institutoRquerimientos');
    localStorage.removeItem('fechaProductoRequerimientos');
    localStorage.removeItem('productoIDRequerimientos');
    localStorage.removeItem('tipoProductoRequerimientos');
    localStorage.removeItem('instituto_empresa');
    localStorage.removeItem('modifUrlShort');
    localStorage.removeItem('bloquear_btn');
    localStorage.removeItem('selectNotice1');
    localStorage.removeItem('selectNotice2');
    localStorage.removeItem('closeNotice');
    localStorage.removeItem('offsetPipe_tmp');
    localStorage.removeItem('nameCity_surveystatus');
    localStorage.removeItem('accesoPortalLanding');
    localStorage.removeItem('nombreEmpresaSelect');
    localStorage.removeItem('tipoIdProducto');
    localStorage.removeItem('nombreEmpresa');
    localStorage.removeItem('customConfig');
    localStorage.removeItem('resultOk');
    localStorage.removeItem('tipoResultForall');
    localStorage.removeItem('tokenEncuestaV3');
    localStorage.removeItem('surveyToken');
    localStorage.removeItem('lastVersion');
    localStorage.removeItem('instituto_Empresa');
    localStorage.removeItem('tipoMedir');
    localStorage.removeItem('productoIDWCP');
    localStorage.removeItem('urlWCPIframe');
    localStorage.removeItem('TokenSurvey');
    localStorage.removeItem('urlGifBroker');
    localStorage.removeItem("ProrrogasAgregadas");
    localStorage.removeItem("idProductoRT");
    localStorage.removeItem("productoIDActionGo");
    localStorage.removeItem("versionResultSuccesGo");
    localStorage.removeItem("categoria");
    localStorage.removeItem('modalAvisoIframe');
    localStorage.removeItem('modalMessageAvisoIframe');
    localStorage.removeItem('tipoIframe');
    localStorage.removeItem('fechaProductorResult');
    localStorage.removeItem('surveySubDomain');
    localStorage.removeItem('ipPublicSubDomain');

    if(!fromODS){
      localStorage.removeItem('userBypass');
    }
  }

  private getAuthData() {
    const token = sessionStorage.getItem('token');
    const tokenVersion = localStorage.getItem('tokenVersion');
    const expirationDate = localStorage.getItem('expiration');
    const idUsuario = localStorage.getItem('idUsuario');
    const instituto = localStorage.getItem('instituto');
    const userData = JSON.parse(localStorage.getItem('userData'));
    if(!token || !expirationDate) {
      return;
    }
    return{
      token,
      expirationDate: new Date(expirationDate),
      idUsuario,
      userData,
      instituto,
      tokenVersion
    }
  }

  autoAuthUser() {
    const authInformation = this.getAuthData();
    if(!authInformation) {
      return;
    }
    const now = new Date();
    const expiresIn = authInformation.expirationDate.getTime() - now.getTime();
    if(expiresIn > 0) {
      this.token = authInformation.token;
      this.tokenVersion = authInformation.tokenVersion;
      this.isAuthenticated = true;
      this.idUsuario = authInformation.idUsuario;
      // this.setDatosUsu();
      this.infoUsu = authInformation.userData;
      this.setAuthTimer(expiresIn);
      this.instituto = authInformation.instituto;
      this.authStatusListener.next({status:true});
      // //notificaciones
      if(this.infoUsu.level == 2 || this.infoUsu.level == 3 || this.infoUsu.level == 11){
        this.qps.enviaToolbar(true);
        this.qps.muestraIcoNotif(true);
      }
      else if(this.infoUsu.level == 1){
        this.qps.muestraIcoNotif(true);
        this.qps.enviaHistorial(true);
      }
    }
  }

  ////////////////////////////////

  loginUser(user: string, password: string,device?:string,browser?:string, productoId?:string,opcion?:string,tipoNom?:any,companyID?:any,dataComplet?:any){
    // console.log("login");
    const authData: backInter.AuthData = { user:user,password:password,device:device,browser:browser,screenResolution:window.screen.width+ ' x '+ window.screen.height,productoId:productoId,opcion:opcion};
    // this.http.post( DATOS_API.url + DATOS_API.endpoints.login, authData)
    console.log('authData',authData);

    this.loginService.login(authData).subscribe((data:backInter.ResponseLogin) => {
      console.log("Respuesta login");
      console.log(data);
      const token = data.dataUser.accessToken;
      this.token = token;
      const tokenVersion = data.dataUser.tokenActualizacion;
      this.tokenVersion = tokenVersion;
      localStorage.setItem('date_log',''+data.dataUser.fecha);
      if(token){
        if(localStorage.getItem('tokenVersion')){
          if(localStorage.getItem('tokenVersion') == tokenVersion){
            this.creaSesion(data,token,tokenVersion,tipoNom,companyID,dataComplet);
          }
          else{
            this.authStatusListener.next({status:false, mensaje:'tokenVersion'});
          }
        }
        else{
          this.creaSesion(data,token,tokenVersion,tipoNom,companyID,dataComplet);
        }
      }
    }, error => {
      console.log("ocurrio un error: ");
      console.log(error);
      this.authStatusListener.next({status:false, mensaje:'errLogIn'});
    });
  }

  login2FA_paso3(datos:any){
    this.token = datos.dataUser.accessToken;
    this.tokenVersion = datos.dataUser.tokenActualizacion;
    localStorage.setItem('date_log', datos.dataUser.fecha);
    if(datos.dataUser.accessToken){
      if(localStorage.getItem('tokenVersion')){
        if(localStorage.getItem('tokenVersion') == datos.dataUser.tokenActualizacion){
          this.creaSesion(datos, datos.dataUser.accessToken, datos.dataUser.tokenActualizacion);
        }
        else{
          this.authStatusListener.next({status:false, mensaje:'tokenVersion'});
        }
      }
      else{
        this.creaSesion(datos, datos.dataUser.accessToken, datos.dataUser.tokenActualizacion);
      }
    }
  }

  creaSesion(data:any, token:string, tokenVersion:string,tipoNom?:any,companyID?:any,dataComplet?:any){
    //guarda la informacion del login
    const idUsuario = data.dataUser.userId;
    this.idUsuario = idUsuario;

    this.setDatosUsu(tipoNom,companyID,dataComplet);

    //calcula la duracion de la sesion en milisegundos
    let expiracion = parseInt(data.dataUser.expiresIn) * 60000;

    //crea el timer de expiracion de sesion
    this.setAuthTimer(expiracion);

    //guarda status de autenticacion y ultimo estatus, ambos TRUE
    this.isAuthenticated = true;
    this.authStatusListener.next({status:true});

    let company: string = '';
    if(data.dataUser.hasOwnProperty('empresaId')){
      company = data.dataUser['empresaId'];
    }

    //id instituto
    let instituto = '';
    if(data.dataUser.hasOwnProperty('instituto')){
      instituto = data.dataUser.instituto.toString();
      localStorage.setItem('instituto_id', data.dataUser.instituto.toString());
    }

    this.instituto = instituto;

    //crea el tiempo en que la sesión debe expirar
    const now = new Date();
    const expirationDate = new Date(now.getTime() + expiracion);
    // console.log("hora actual: "+now);
    // console.log("hora expiracion: "+expirationDate);

    let empresaPadre: string;
    if(data.dataUser.empresaPadre){
      empresaPadre = data.dataUser.empresaPadre;
    }

    //guarda la informacion en local storage: token, expiracion y respuesta con array de info
    this.saveAuthData(token, tokenVersion, expirationDate, idUsuario,company, instituto, empresaPadre);
  }

  loginFromODS(token:string, idEmpresa:string){
    // console.log(data);
    if(token){
      // console.log("entro login ods, token:"+token+" : idusuario:"+idEmpresa);
      this.token = token;
      this.userService.getUserEmpresa(idEmpresa).subscribe((respuesta:backInter.getUsuarioEmpresa) => {
        console.log("Login from ods");
        console.log(respuesta);
        //guarda la informacion del login
        // idUsuario = '5e335910c33a5f78e20eac8f';
        let idUsuario = respuesta.usuario._id;
        this.idUsuario = respuesta.usuario._id;
        // this.setDatosUsu();

        this.userService.getUserData(this.idUsuario).subscribe((data:backInter.infoUsuarioResp) => {
          console.log(data);
          this.infoUsu = data.data;
          localStorage.setItem('userData', JSON.stringify(this.infoUsu));
          //calcula la duracion de la sesion en milisegundos
          let expiracion = 120 * 60000;

          //crea el timer de expiracion de sesion
          this.setAuthTimer(expiracion);

          //guarda status de autenticacion y ultimo estatus, ambos TRUE
          this.isAuthenticated = true;
          this.authStatusListener.next({status:true});

          let company = this.infoUsu.empresaId;

          //id instituto
          let instituto = this.infoUsu.institutoId.toString();

          this.instituto = this.infoUsu.institutoId.toString();

          //crea el tiempo en que la sesión debe expirar
          const now = new Date();
          const expirationDate = new Date(now.getTime() + expiracion);

          // this.qps.muestraIcoNotif(false);

          //guarda la informacion en local storage: token, expiracion y respuesta con array de info
          this.saveAuthData(token, localStorage.getItem('tokenVersion'), expirationDate, idUsuario,company, instituto);
          //redirige a home
          let url: string;
          console.log("nivel nivel nivel",data.data.level);

          switch(data.data.level){
            case 6: url = '/NOM35'; break;
            // case 1: url = '/results/trust_index/certificar';
            // break;
            default: url = '/home';
          }
          this.router.navigate([url]);
        }, error  => {
          console.log("error");
        });

      }, error  => {
        console.log("error");
      });
    }
  }

  //obtiene los datos del usuario
  setDatosUsu(tipoNom?:any, companyID?:any,dataComplet?:any){
    this.userService.getUserData(this.idUsuario).subscribe((data:backInter.infoUsuarioResp) => {
      console.log('setDatosUsu datosUsu.::::::::::::::::::::',data);
      //colocaIDinstituto
      localStorage.setItem('NivelUsuarioRequerimientosTecnicos',data.data.level.toString());
      if(data.data.level == 3){
        localStorage.setItem('instituto',"0");
      }
      else{
        if(data.data.institutoId){
          localStorage.setItem('instituto',data.data.institutoId.toString());
        }
      }
      //notificaciones
      if(data.data.level == 2 || data.data.level == 3 || data.data.level == 11){
        this.qps.enviaToolbar(true);
        this.qps.muestraIcoNotif(true);
      }
      else if(data.data.level == 1){
        this.qps.muestraIcoNotif(true);
        this.qps.enviaHistorial(true);
      }
      //notificaciones
      localStorage.setItem('id_CT', data.data.id_CT);
      localStorage.setItem('productoIdNorm35', data.data.productoId);
        this.infoUsu = data.data;
        localStorage.setItem('userData', JSON.stringify(this.infoUsu));
        //redirige a home
        let url: string;
        console.log("dataComplet",dataComplet);
  switch(data.data.level){
    case 6:
    localStorage.setItem('productoID',dataComplet.productoID);
    localStorage.setItem('FechaNorma',dataComplet.FechaNorma);
    localStorage.setItem('companyID',companyID);
    if (tipoNom=='v3') {
      url="/NOM35-v3"
    }else{
      url = '/NOM35';
    }
    break;
    case 1: case 4: case 19:
    switch (data.data.institutoId) {
      case 2:
      url = '/home';
        break;
      default:
      url = '/homepage';
        break;
    }
    break;
    default: url = '/home';
  }
  this.router.navigate([url]);
      }, error  => {
        console.log("error");
      });
  }

  getIdiomasGuardados(){
    const idEmpresa = this.getCompanyID();
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.idiomasGuardados + idEmpresa);
  }

  private getCompanyID():string{
    const token = localStorage.getItem('companyID');

    return token;
  }



  logout_log(){
    let idEmpresa = localStorage.getItem('companyID') != undefined ? localStorage.getItem('companyID') : '0';
    let datos: any = {
      accionText: 'LogOut',
      userAdministrator: ''
    };
    if(localStorage.getItem('userBypass')){
      let datosAdmin = JSON.parse(localStorage.getItem('userBypass'));
      datos.userAdministrator = datosAdmin.user;
    }
    return this.http.post( DATOS_API.url + DATOS_API.endpoints.autenticacion.logout + idEmpresa, datos).subscribe((respuesta) => console.log("logout:",respuesta));
  }

  logout(autologin?:any, fromODS?:any) {
    console.log('autologin',autologin);
    let tokenTemp = this.token;
    this.token = null;
    this.isAuthenticated = false;
    this.idUsuario = null;
    this.infoUsu = null;
    this.instituto = null;
    this.authStatusListener.next(false);
    //condicion para guardar datos del usuario itbm antes que se borre alv
    if(fromODS){
      localStorage.setItem('userBypass', localStorage.getItem('userData'));
    }
    clearTimeout(this.tokenTimer);
    this.clearAuthData(fromODS);
    if(!autologin && !fromODS){
      // this.router.navigate(['/login']);
      this.router.navigate(['/logout']);
      sessionStorage.clear(); //Limpiar variables de sesión
    }
    else if(!autologin && fromODS){
      // this.router.navigate(['/login']);
      this.router.navigate(['/logout',tokenTemp]);
      this.loginFromODS(tokenTemp,fromODS);
    }
    else{
      this.router.navigate(['/logout',tokenTemp]);
      const d=document,n=navigator,ua= n.userAgent;
      console.log("si jalo ",ua);
      this.detectorDispositivof(ua);
      this.detectorNavegadorf(ua);

      this.loginUser(autologin.user,autologin.password,this.detectorDispositivo,this.detectorNavegador,autologin.productoId,"SI",autologin.tipoNom,autologin.companyID,autologin);
    }
  }

  detectorDispositivof(ua){
  let tipoDispositvo={
   android:()=> ua.match(/android/i),
   ios:()=> ua.match(/iphone|ipad|ipod/i),
   windowsphone:()=> ua.match(/windows phone/i),
   linux:()=>ua.match(/linux/i),
   windows:()=>ua.match(/windows nt/i),
   mac:()=>ua.match(/mac os/i),
   any:function(){
     return this.android() ||this.ios() ||this.ios() ||this.linux()||this.windows()||this.mac();
   }

  }
  this.detectorDispositivo=tipoDispositvo.any();
  console.log("tipoDispositvo",this.detectorDispositivo);


  }

  detectorNavegadorf(ua){
  let tipoNavegador={
   chrome:()=> ua.match(/chrome/i),
   safari:()=> ua.match(/safari/i),
   firefox:()=> ua.match(/firefox/i),
   opera:()=>ua.match(/opera/i),
   ie:()=>ua.match(/msie|iemobile/i),
   edge:()=>ua.match(/edge/i),
   any:function(){
     return this.chrome() ||this.safari() ||this.firefox() ||this.opera()||this.ie()||this.edge();
   }

  }
  console.log("tipoNavegador",tipoNavegador.any());
  this.detectorNavegador=tipoNavegador.any();
  console.log("tipoNavegador",this.detectorNavegador);
  }

  puenteDatos(mensaje: string) {
    this.mensajeOrigen.next(mensaje);
  }

  puenteDatosQuick(mensaje:any) {
    this.mensajeOrigenQuick.next(mensaje);
  }

  puenteDatosNotificacionesToolbar(mensaje: string) {
    this.mensajeOrigenToolbarNotif.next(mensaje);
  }
  saveLogo(datos: any) {
    const idEmpresa = this.getCompanyID();
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.logoEmpresa + idEmpresa,datos);
  }
  getLogo(empresaPadre?:string){
    let idEmpresa:string;
    if(!empresaPadre)
      idEmpresa = this.getCompanyID();
    else idEmpresa = empresaPadre;
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.getLogoEmpresa + idEmpresa);
  }

  getMantenimiento(){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.getMantenimiento);
  }

  bodyarreglo:any;
  acortadorUrl(username: string, password: string, url:string,title:string) {
    const body = new HttpParams()
    .set('username', username)
    .set('password', password)
    .set('action', 'shorturl')
    .set('url', url)
    .set('format', 'json')
    .set('title', title);
    return this.http.post('http://gptw.global/yourls-api.php',
    body.toString(),
      {
        headers: new HttpHeaders()
        .set('Content-Type', 'application/x-www-form-urlencoded')
      }
    );

  }
  pruebaAcortador(username: any, password: any, url:any,title:any){
    const body = new HttpParams()
      .set('username', username)
      .set('password', password)
      .set('action', 'shorturl')
      .set('url', url)
      .set('format', 'json')
      .set('title', title);

      console.log("Body");
      console.log(body);

     return this.http.post('http://gptw.global/yourls-api.php',
       body.toString(),
       {
         headers: new HttpHeaders()
           .set('Content-Type', 'application/x-www-form-urlencoded')
       }
     );
  }

  acortadorDos(user: string, password: string, url:string, title:string) {
    /*const body = new HttpParams()
      .set(`user`, user)
      .set(`password`, password)
      .set(`action`, `shorturl`)
      .set(`url`, url)
      .set(`format`, `json`)
      .set(`title`, title);
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });*/
    let action="shorturl";
    let format ="json";
    let body = `username=${user}&password=${password}&action=${action}&url=${url}&format=${format}&title=${title}`;
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    console.log("body");
    console.log(body);
    return this.http.post('http://gptw.global/yourls-api.phpn', body, { headers: headers });

    //return this.http.post(`http://gptw.global/yourls-api.phpn`, body.toString(), { headers, observe: 'response' });
  }


}
